import {
  GET_ANNOUNCEMENTS_LOGO_ASYNC,
  SUBMIT_ANNOUNCEMENTS_LOGO_ASYNC,
  UPDATE_ANNOUNCEMENTS_LOGO,
} from './constants'

const getAnnouncementsLogo = (data) => ({
  type: GET_ANNOUNCEMENTS_LOGO_ASYNC.INITIATE,
  payload: { data },
})
const getAnnouncementsLogoCancel = () => ({
  type: GET_ANNOUNCEMENTS_LOGO_ASYNC.CANCEL,
})
export const getAnnouncementsLogoSuccess = (data) => ({
  type: GET_ANNOUNCEMENTS_LOGO_ASYNC.SUCCESS,
  payload: { data },
})
export const getAnnouncementsLogoError = (error) => ({
  type: GET_ANNOUNCEMENTS_LOGO_ASYNC.ERROR,
  error,
})

const updateAnnouncementsLogo = (data) => ({
  type: UPDATE_ANNOUNCEMENTS_LOGO,
  payload: { data },
})

const submitAnnouncementsLogo = () => ({
  type: SUBMIT_ANNOUNCEMENTS_LOGO_ASYNC.INITIATE,
})
const submitAnnouncementsLogoCancel = () => ({
  type: SUBMIT_ANNOUNCEMENTS_LOGO_ASYNC.CANCEL,
})
export const submitAnnouncementsLogoSuccess = (data) => ({
  type: SUBMIT_ANNOUNCEMENTS_LOGO_ASYNC.SUCCESS,
  payload: { data },
})
export const submitAnnouncementsLogoError = (error) => ({
  type: SUBMIT_ANNOUNCEMENTS_LOGO_ASYNC.ERROR,
  error,
})

export default {
  // to props
  getAnnouncementsLogo,
  getAnnouncementsLogoCancel,
  submitAnnouncementsLogo,
  submitAnnouncementsLogoCancel,
  updateAnnouncementsLogo,
}
